import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  Box,
  Button,
  InputAdornment,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "../../appStore";
import axios from "axios";
import { api_url } from "../../apiUtils";
import LoginDialog from "./loginDialog";
import { ThreeDots } from "react-loader-spinner";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import BackgroundAnimation from "./backgrundAnimation";
import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
import ResultTable from "../../pages/login/ResultTable";

const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  pt: 2,
  px: 4,
  py: 4,
  textAlign: "center",
};

const validationSchema = yup.object({
  mobileNumber: yup
    .string()
    // .matches(/^\d{10}$/, "Invalid phone number format")
    .required("Phone number is required"),
  password: yup.string().required("Password is required"),
});

function LoginForm() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { setProfileData, setProfileDetails } = useAppStore();
  const phoneInputRef = useRef(null);
  const passwordInputRef = useRef(null);

  useEffect(() => {
    if (phoneInputRef.current) {
      phoneInputRef.current.focus();
    }
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  function generateSessionId() {
    return Math.random().toString(36).substr(2, 9);
  }

  const fetchProfileDetails = async () => {
    try {
      const response = await axios.get(api_url + "auth/profile", {
        headers: {
          accesstoken: sessionStorage.getItem("accesstoken"),
        },
      });
      const data = response.data;

      if (data.status === "success") console.log(data);
      formik.setValues({
        mobileNumber: data?.userProfile?.primaryPhone?.contactValue,
        password: "",
        name: data?.userProfile?.name,
      });
      setProfileDetails(data?.userProfile);
    } catch (error) {
      console.error("Error: ", error);
    }
  };

  const formik = useFormik({
    initialValues: {
      mobileNumber: "",
      password: "",
      role: "customer",
    },
    validationSchema: validationSchema,

    onSubmit: (values, { resetForm }) => {
      setIsLoading(true);

      const encryptedMobileNumber = CryptoJS.AES.encrypt(
        values.mobileNumber,
        "math_secret"
      ).toString();
      const encryptedPassword = CryptoJS.AES.encrypt(
        values.password,
        "math_secret"
      ).toString();

      axios
        .post(
          `${api_url}auth/login`,
          {
            mobileNumber: encryptedMobileNumber,
            password: encryptedPassword,
            role: values.role,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          const data = response.data;
          console.log("data", data);
          if (data.user?.disabled) {
            setError("Your account has been disabled");
            setIsLoading(false);
            return;
          }
          if (data.status === "success") {
            setError("");
            if (data.user.role === "customer") {
              setTimeout(() => {
                setIsLoading(false);
                setProfileData(data.user);

                const sessionId = generateSessionId();
                sessionStorage.setItem("sessionId", sessionId);
                sessionStorage.setItem("accesstoken", data.accessToken.value);
                fetchProfileDetails();
                toast.success("Logged in successfully.");
                navigate("/home/menus");
                resetForm({
                  values: {
                    mobileNumber: "",
                    password: "",
                    role: "",
                  },
                });
              }, 1000);
            } else {
              setIsLoading(false);
              setError("Login failed. Please check your credentials.");
            }
          } else {
            setError("Login failed. Please check your credentials.");
          }
        })
        .catch((error) => {
          setIsLoading(false);
          if (error && error.response) {
            setError(error.response.data.message);
          } else if (error && error.request) {
            setError(
              "Unable to connect to the server. Please try again later."
            );
          }
        });
    },
  });

  const handlemobileNumberChange = (event) => {
    setError("");
    const inputmobileNumber = event.target.value;
    if (/^\d{0,10}$/.test(inputmobileNumber)) {
      formik.handleChange(event);
      if (inputmobileNumber.length === 10) {
        passwordInputRef.current.focus();
      }
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    formik.handleSubmit();
  };

  return (
    <div>
      {/* <BackgroundAnimation /> */}

      <form onSubmit={handleFormSubmit}>
        <Box
          sx={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            padding: { xs: "0px 30px", sm: "0px 80px", md: "0px 100px" },
            flexDirection: "column",
            minHeight: { xs: "100vh", sm: "90vh", xl: "80vh" },
          }}
        >
          <Box sx={{ background: "#f9a825 ", p: 0.5, mb: 4 }}>
            <Typography
              sx={{
                fontWeight: "bold",
                letterSpacing: 1,
                textAlign: "center",
                fontSize: { xs: "12px", sm: "16px" },
              }}
            >
              "VISHWAS KA DHANDHA - VISHWAS KE SAATH"
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <img
              width={"110px"}
              src="images/sm-logo.png"
              alt="no image found"
              style={{ filter: "contrast(150%)" }}
            />
          </Box>
          <Box mt={3} />
          {error ? (
            <Alert variant="outlined" severity="error">
              {error}
            </Alert>
          ) : (
            ""
          )}
          <Box mt={1}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              id="mobileNumber"
              name="mobileNumber"
              placeholder="Phone Number"
              error={formik.touched.mobileNumber && formik.errors.mobileNumber}
              helperText={
                formik.touched.mobileNumber && formik.errors.mobileNumber
              }
              value={formik.values.mobileNumber}
              onChange={handlemobileNumberChange}
              onBlur={formik.handleBlur}
              inputRef={phoneInputRef}
            />
          </Box>
          <Box mt={3}>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              id="password"
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              error={formik.touched.password && formik.errors.password}
              helperText={formik.touched.password && formik.errors.password}
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              inputRef={passwordInputRef}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Box
                      onClick={togglePasswordVisibility}
                      sx={{ mt: 0.6, cursor: "pointer" }}
                    >
                      {showPassword ? (
                        <VisibilityOffIcon sx={{ color: "#9e9e9e" }} />
                      ) : (
                        <VisibilityIcon sx={{ color: "#9e9e9e" }} />
                      )}
                    </Box>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          {/* <Box mt={1} sx={{ textAlign: "right" }}>
            <Typography
              sx={{ fontSize: "14px", color: "blue", cursor: "pointer" }}
              onClick={() => navigate("/forgot-password")}
              onMouseEnter={(e) => (e.target.style.color = "red")}
              onMouseLeave={(e) => (e.target.style.color = "blue")}
            >
              Forgot Password?
            </Typography>
          </Box> */}

          <Box mt={4} sx={{ textAlign: "center" }}>
            {isLoading ? (
              <Button
                variant="outlined"
                type="submit"
                sx={{
                  textTransform: "capitalize",
                  backgroundColor: "#FFFFFF",
                  borderColor: "#FFB320",
                  p: "0px 60px",
                  borderRadius: 6,
                  fontWeight: "bold",
                  width: { xs: "150px", sm: "200px" },
                  "&:hover": {
                    backgroundColor: "#FFFFFF",
                    borderColor: "#FFB320",
                  },
                }}
              >
                <ThreeDots width={40} height={40} />
              </Button>
            ) : (
              <Button
                variant="contained"
                type="submit"
                sx={{
                  textTransform: "capitalize",
                  backgroundColor: "#FFB320",
                  p: "7px 60px",
                  borderRadius: 6,
                  fontWeight: "bold",
                  width: { xs: "150px", sm: "200px" },
                  letterSpacing: 1,
                }}
                disabled={error === "Error: User is already logged in."}
              >
                Login
              </Button>
            )}
          </Box>
          <Box my={3} sx={{ textAlign: "center" }}>
            <Typography sx={{ fontSize: "16px", fontWeight: "bold" }}>
              New on our platform?{" "}
              <span
                style={{ color: "blue", cursor: "pointer" }}
                onClick={() => navigate("/register")}
                onMouseEnter={(e) => (e.target.style.color = "red")}
                onMouseLeave={(e) => (e.target.style.color = "blue")}
              >
                Create an account
              </span>
            </Typography>
          </Box>
          <Box>
            <ResultTable />
          </Box>
        </Box>
      </form>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style2}>
          <LoginDialog />
        </Box>
      </Modal>
    </div>
  );
}

export default LoginForm;
